<app-loading *ngIf="!isDataLoaded"></app-loading>
<div *ngIf="!isDialog">
  <div *ngIf="isDataLoaded" class="container">
    <div *ngIf="okrs.length === 0" class="no-records">
      {{ commonText.no_records_found }}
    </div>
    <div class="accordion" id="objectiveAccordion">
      <div class="accordion-item" *ngFor="let obj of okrs; let oi = index">
        <h2 class="accordion-header objective-header" id="headingObj{{ oi }}">
          <button
            class="accordion-button {{ oi === 0 ? '' : 'collapsed' }}"
            type="button"
            data-bs-toggle="collapse"
            attr.data-bs-target="#collapseObj{{ oi }}"
            aria-expanded="{{ oi === 0 ? 'true' : 'false' }}"
            aria-controls="collapseObj{{ oi }}"
          >
            <div class="label-tag" style="margin-top: 2px">Objective</div>
            <div class="accordion-info">
              <div>
                <div class="accordion-title">{{ obj.objective_title }}</div>

                <div class="objective-meta">
                  <span class="mini-chip"
                    >{{ obj.key_results?.length | appFormat: 'number' }} KRs</span
                  >
                  <span class="mini-chip"
                    >{{ getObjectiveGoalCount(obj) | appFormat: 'number' }} Goals</span
                  >
                  <span class="mini-chip" *ngIf="!projectId"
                    >{{ getObjectiveProjectCount(obj) | appFormat: 'number' }} {{displayLabels?.project | titlecase}}s</span
                  >
                </div>
              </div>

              <!-- 
            <div class="bar-wrapper">
              <div class="bar" [ngClass]="getBarClass(obj.objective_progress)">
                <b [style.width.%]="obj.objective_progress"></b>
              </div>
              <div class="bar-label">
                Objective Progress:
                {{ obj.objective_progress | number : "1.0-0" }}%
              </div>
              <div class="objective-meta">
                <span class="mini-chip">{{ obj.key_results?.length }} KRs</span>
                <span class="mini-chip"
                  >{{ getObjectiveGoalCount(obj) }} Goals</span
                >
                <span class="mini-chip"
                  >{{ getObjectiveProjectCount(obj) }} Projects</span
                >
              </div>
            </div> -->
            </div>
            <highcharts-chart
              [Highcharts]="Highcharts"
              [options]="obj.chartOptions"
              style="width: 150px; height: 100px; display: block"
            >
            </highcharts-chart>
          </button>
        </h2>

        <div
          id="collapseObj{{ oi }}"
          class="accordion-collapse collapse {{ oi === 0 ? 'show' : '' }}"
          aria-labelledby="headingObj{{ oi }}"
          data-bs-parent="#objectiveAccordion"
        >
          <div class="accordion-body">
            <div class="accordion" id="krAccordion{{ oi }}">
              <div
                class="accordion-item"
                *ngFor="let kr of obj.key_results; let ki = index"
              >
                <h2
                  class="accordion-header kr-header"
                  id="headingKr{{ oi }}-{{ ki }}"
                >
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    attr.data-bs-target="#collapseKr{{ oi }}-{{ ki }}"
                    aria-expanded="false"
                    aria-controls="collapseKr{{ oi }}-{{ ki }}"
                  >
                    <div class="label-tag" style="margin-top: 2px">
                      Key Result
                    </div>
                    <div class="accordion-info">
                      <div>
                        <div class="accordion-title">
                          {{ kr.key_result_title }}
                        </div>
                        <div class="kr-meta">
                          <span class="mini-chip"
                            >{{ kr.goals?.length | appFormat: 'number' }} Goals</span
                          >
                        </div>
                      </div>

                      <!-- <div class="bar-wrapper">
                      <div
                        class="bar"
                        [ngClass]="getBarClass(kr.key_result_progress)"
                      >
                        <b [style.width.%]="kr.key_result_progress"></b>
                      </div>
                      <div class="bar-label">
                        Key Result Progress:
                        {{ kr.key_result_progress | number : "1.0-0" }}%
                      </div>
                      <div class="kr-meta">
                        <span class="mini-chip"
                          >{{ kr.goals?.length }} Goals</span
                        >
                      </div>
                    </div> -->
                    </div>
                    <highcharts-chart
                      [Highcharts]="Highcharts"
                      [options]="kr.chartOptions"
                      style="width: 150px; height: 100px; display: block"
                    >
                    </highcharts-chart>
                  </button>
                </h2>

                <div
                  id="collapseKr{{ oi }}-{{ ki }}"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingKr{{ oi }}-{{ ki }}"
                  data-bs-parent="#krAccordion{{ oi }}"
                >
                  <div class="accordion-body">
                    <div
                      class="lanes"
                      [ngClass]="kr.goals?.length > 1 ? 'scroll-x' : 'single'"
                    >
                      <article class="lane" *ngFor="let goal of kr.goals">
                        <div class="label-tag" style="margin-top: 2px">
                          Goal
                        </div>
                        <div class="lane-head">
                          <div
                            class="lane-title"
                            matTooltip="{{ goal.goal_name }}"
                          >
                            {{ goal.goal_name }}
                          </div>
                          <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="goal.chartOptions"
                            style="width: 110px; height: 80px; display: block"
                          >
                          </highcharts-chart>
                        </div>

                        <!-- <div
                        class="bar lane-bar"
                        [ngClass]="getBarClass(goal.goal_progress)"
                      >
                        <b [style.width.%]="goal.goal_progress"></b>
                      </div>
                      <div class="bar-label">
                        Goal Progress:
                        {{ goal.goal_progress | number : "1.0-0" }}%
                      </div> -->
                        <div class="lane-meta">
                          <span class="mini-chip" *ngIf="!projectId"
                            >{{ goal.projects?.length | appFormat: 'number' }} {{displayLabels?.project | titlecase}}s</span
                          >
                          <span class="mini-chip"
                            >{{
                              goal.projects[0]?.metrics?.length || 0 | appFormat: 'number'
                            }}
                            Metrics</span
                          >
                        </div>

                        <div class="metric-grid" *ngIf="goal.projects?.length">
                          <table class="mg">
                            <thead>
                              <tr>
                                <th>{{displayLabels?.project | titlecase}}</th>
                                <th
                                  *ngFor="
                                    let m of goal.projects[0]?.metrics || []
                                  "
                                  class="metric-th"
                                  style="text-align: right"
                                >
                                  <span
                                    class="metric-label"
                                    matTooltip="{{ m.metric_display_name }}"
                                    matTooltipPosition="above"
                                  >
                                    {{ m.metric_display_name }}
                                  </span>
                                  <span class="target">
                                    Target: {{ m.target_value ?? "—" | appFormat: 'number' }}
                                  </span>
                                  <span class="unit"
                                    >Unit:
                                    <app-metrics-icon
                                      [unit_name]="m.unit"
                                      [scale]="0.65"
                                    ></app-metrics-icon>
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let p of sortProjects(goal.projects).slice(
                                    getCurrentPage(oi, ki, goal.goal_id) *
                                      PAGE_SIZE,
                                    (getCurrentPage(oi, ki, goal.goal_id) + 1) *
                                      PAGE_SIZE
                                  )
                                "
                              >
                                <td>
                                  <div class="proj-cell">
                                    <div
                                      class="dot"
                                      [ngClass]="'okr-' + p.project_color"
                                    ></div>
                                    <div
                                      class="proj-name"
                                      matTooltip="{{ p.project_name }}"
                                    >
                                      {{ p.project_name }}
                                    </div>
                                  </div>
                                </td>
                                <td *ngFor="let m of p.metrics" class="val">
                                  <span
                                    class="value-chip"
                                    [ngClass]="'okr-' + m.metric_color"
                                  >
                                    {{ formatNumber(m.latest_value) ?? "—" | appFormat: 'number' }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div
                          class="pager"
                          *ngIf="goal.projects?.length > PAGE_SIZE"
                        >
                          <button
                            class="btn"
                            (click)="
                              setPage(
                                oi,
                                ki,
                                goal.goal_id,
                                -1,
                                goal.projects.length
                              )
                            "
                            [disabled]="
                              getCurrentPage(oi, ki, goal.goal_id) === 0
                            "
                          >
                            ‹ Prev
                          </button>
                          <div class="info">
                            Page
                            {{ getCurrentPage(oi, ki, goal.goal_id) + 1 }} /
                            {{ getTotalPages(goal) }}
                          </div>
                          <button
                            class="btn"
                            (click)="
                              setPage(
                                oi,
                                ki,
                                goal.goal_id,
                                1,
                                goal.projects.length
                              )
                            "
                            [disabled]="
                              getCurrentPage(oi, ki, goal.goal_id) >=
                              getTotalPages(goal) - 1
                            "
                          >
                            Next ›
                          </button>
                        </div>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isDialog">
  <div *ngIf="okrs?.length; else noRecords" class="gauge-container">
    <div class="gauge-heading">{{displayLabels?.project | titlecase}} Contribution</div>

    <span class="mini-chip-okr">
      {{ getObjectiveCount() | appFormat : "number" }} Objectives

      <div class="tooltip-card-list" *ngIf="okrs?.length">
        <div class="tooltip-card" *ngFor="let obj of okrs">
          {{ obj.objective_title }}
        </div>
      </div>
    </span>

    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="averageChartOptions"
      style="width: 180px; height: 120px; display: block"
    ></highcharts-chart>
  </div>

  <ng-template #noRecords>
    <div class="no-records">
      {{ commonText.no_records_found }}
    </div>
  </ng-template>
</div>
